import React from 'react';
import { HorizontalToggle } from '@hc/component-lib/hclib/components/atoms/horizontal-toggle';
import { useSelector, useDispatch } from 'react-redux';
import { getChartDataSelectedValuationChartType } from 'selectors/chart-data';
import { chartDataValuationChartTypeSelect } from 'actions/chart-data';
import { VALUATION_CHART_TYPE_TOGGLE_OPTIONS } from 'legacy/appstore/constants';
import ValuationChartContainer from 'legacy/containers/property-explorer-valuation-chart';
import { ValuationChartSection as styles } from 'legacy/css-modules';

export const ValuationChartSection = () => {
  const dispatch = useDispatch();
  const chartType = useSelector(getChartDataSelectedValuationChartType);
  return (
    <section>
      <div className={styles.Controls}>
        <HorizontalToggle
          value={chartType}
          options={VALUATION_CHART_TYPE_TOGGLE_OPTIONS}
          onSelect={(v) => dispatch(chartDataValuationChartTypeSelect(v))}
        />
      </div>
      <ValuationChartContainer key={chartType} />
    </section>
  );
};
